import toast from 'react-hot-toast';
import { exchangeSsoHandoff } from '../linkedAppSso';

export async function ssoFinalize(payload, login) {
  if (!payload) return false;
  try {
    if (payload.token) await exchangeSsoHandoff(payload.token, '/request/sso-handoff');
    const response = await fetch('/request/check-session', { credentials: 'include' });
    const data = await response.json();
    if (!response.ok || !data.success || !data.user) throw new Error('통합 로그인 확인에 실패했습니다.');
    sessionStorage.setItem('user', JSON.stringify(data.user));
    login(data.user);
    toast.success('로그인되었습니다.');
    return true;
  } catch (error) {
    toast.error(error.message || '통합 로그인 연결에 실패했습니다.');
    return false;
  }
}
